import React from 'react';
import { FadeIn } from './FadeIn';
import { Book, Utensils, ShoppingCart, Droplets, BookOpen } from 'lucide-react';
const deliverables = [{
  icon: <Book className="w-8 h-8 text-sage" data-id="element-61" />,
  title: 'Guía Maestra Protocolo SOS',
  desc: 'El paso a paso detallado para ejecutar el Bio-Reset de 3 días.'
}, {
  icon: <Utensils className="w-8 h-8 text-sage" data-id="element-62" />,
  title: 'Menú de Rescate Diario',
  desc: 'Desayuno, comida y cena diseñados para desactivar la insulina y calmar el intestino.'
}, {
  icon: <ShoppingCart className="w-8 h-8 text-sage" data-id="element-63" />,
  title: 'Lista de Compras de Emergencia',
  desc: 'Ve directo al grano en el supermercado sin dudas ni errores.'
}, {
  icon: <Droplets className="w-8 h-8 text-sage" data-id="element-64" />,
  title: 'Método de Hidratación 3-3-3',
  desc: 'La fórmula exacta para drenar toxinas sin desmineralizarte.'
}, {
  icon: <BookOpen className="w-8 h-8 text-sage" data-id="element-65" />,
  title: 'Diario de Reintroducción',
  desc: 'El sistema para descubrir exactamente qué alimento te inflama a TI después del protocolo.'
}];
export function DeliverablesSection() {
  return <section className="py-12 md:py-24 bg-cream" data-id="element-66">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-67">
        <FadeIn data-id="element-68">
          <div className="text-center mb-8 md:mb-16" data-id="element-69">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-70">
              Todo lo que recibes hoy
            </h2>
            <p className="text-lg text-gray-600" data-id="element-71">
              Un sistema completo, sin relleno, diseñado para la acción
              inmediata.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-72">
          {deliverables.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-73">
              <div className="bg-white p-8 rounded-2xl shadow-sm border border-mint/50 h-full flex flex-col items-center text-center hover:-translate-y-1 transition-transform duration-300" data-id="element-74">
                <div className="w-16 h-16 bg-mint rounded-full flex items-center justify-center mb-6" data-id="element-75">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold text-forest mb-3 font-sans" data-id="element-76">
                  {item.title}
                </h3>
                <p className="text-gray-600" data-id="element-77">{item.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}